import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import PrivacyPolicy from "./PrivacyPolicy";
import AccountDeletion from "./AccountDeletion";
import "./App.css";

function Home() {
  return (
    <div className="max-w-4xl mx-auto px-5 py-10 text-center bg-gray-50 min-h-screen">
      <h1 className="text-4xl font-bold text-slate-700 mb-4">
        طفل المستقبل - mostaqbal kids
      </h1>
      <p className="text-xl text-gray-600 mb-8">Educational App for Children</p>

      <div className="space-y-4">
        <div>
          <Link
            to="/privacy-policy"
            className="inline-block bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition-colors mr-4"
          >
            Privacy Policy
          </Link>
          <Link
            to="/delete-account"
            className="inline-block bg-red-500 text-white px-6 py-3 rounded-lg hover:bg-red-600 transition-colors"
          >
            Delete Account
          </Link>
        </div>

        <div className="mt-8 text-sm text-gray-500">
          <p>
            For support:{" "}
            <a
              href="mailto:support@mostaqbalkids.com"
              className="text-blue-600"
            >
              support@mostaqbalkids.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/delete-account" element={<AccountDeletion />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
